import { GetServerSideProps } from 'next'
import Layout from 'components/layout'
import routes from 'routes'
import { NextSeo } from 'next-seo'
import Breadcrumb from 'components/breadcrumb'
import TitleBar from 'components/title-bar'
import Link from 'next/link'
import NumberPagination from 'components/number-pagination'
import api from 'services/api'

const filters = '#ABCDEFGHIJKLMNOPQRSTUVWXYZ'
const LIMIT = 100

const Tags = ({
  keyword,
  pages,
  total,
  keywords,
}: {
  keyword: string
  pages: number
  total: number
  keywords: string[]
}): JSX.Element => {
  return (
    <Layout>
      <NextSeo
        title={`Find 10+ Results for ${keyword} - AnyStorie`}
        description={`Already find over 10 results for ${keyword} on AnyStories, check the results now!`}
        canonical={routes.keywords.index({ keyword, pages })}
      />
      <TitleBar title={'Keywords'} />
      <div className="hidden lg:block px-4 py-3">
        <Breadcrumb
          className="mr-4"
          items={[
            {
              name: 'Keywords',
              link: '/keywords/0/1',
            },
            {
              name: keyword === '0' ? '#' : keyword,
            },
          ]}
        />
      </div>
      <div className="flex items-center justify-between p-4 overflow-hidden">
        <div className="flex md:justify-center items-center w-full overflow-x-auto">
          {filters.split('').map((item: string, index: number) => (
            <Link
              href={routes.keywords.index({
                keyword: item === '#' ? '0' : item,
              })}
              key={index}
              className={`text-xl px-3 py-2 border-b-2 border-transparent hover:text-goldenrod ${
                keyword === item || (keyword === '0' && item === '#')
                  ? ' text-goldenrod font-extrabold border-b-2 !border-goldenrod'
                  : ''
              }`}
            >
              {item}
            </Link>
          ))}
        </div>
      </div>
      <div className="p-4 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-x-12 gap-y-8">
        {keywords.map((item: string, index: number) => (
          <Link
            href={routes.search.search({
              keywords: item.trim().replaceAll(' ', '+'),
            })}
            className="line-clamp-1 hover:text-goldenrod"
            key={index}
          >
            {item}
          </Link>
        ))}
      </div>
      {total > 1 && (
        <div className="py-4">
          <NumberPagination
            current={pages}
            total={total}
            linkGeneration={(current: number) =>
              routes.keywords.index({ keyword, pages: current })
            }
          />
        </div>
      )}
    </Layout>
  )
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  const keyword = context.params.slug as string
  const pages = +(context.params.pages as string)
  const data = await api.keywords.getKeywords({
    key: keyword,
    pageindex: pages,
    pagesize: LIMIT,
  })
  return {
    props: {
      keyword,
      pages,
      total: Math.ceil(data.totalCount / LIMIT),
      keywords: data.items,
    },
  }
}

export default Tags
